import { render } from "./UangKeluarAddModal.vue?vue&type=template&id=c2e457ea&scoped=true"
import script from "./UangKeluarAddModal.vue?vue&type=script&lang=js"
export * from "./UangKeluarAddModal.vue?vue&type=script&lang=js"

import "./UangKeluarAddModal.vue?vue&type=style&index=0&id=c2e457ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2e457ea"

export default script